import { render, staticRenderFns } from "./footview.vue?vue&type=template&id=6829f1cb&scoped=true&"
import script from "./footview.vue?vue&type=script&lang=js&"
export * from "./footview.vue?vue&type=script&lang=js&"
import style0 from "./footview.vue?vue&type=style&index=0&id=6829f1cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829f1cb",
  null
  
)

export default component.exports